/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchRealEstateDto } from './SearchRealEstateDto';
import {
    SearchRealEstateDtoFromJSON,
    SearchRealEstateDtoFromJSONTyped,
    SearchRealEstateDtoToJSON,
    SearchRealEstateDtoToJSONTyped,
} from './SearchRealEstateDto';

/**
 * Response containing search results for real estates
 * @export
 * @interface SearchRealEstatesResponse
 */
export interface SearchRealEstatesResponse {
    /**
     * List of matching real estate properties
     * @type {Array<SearchRealEstateDto>}
     * @memberof SearchRealEstatesResponse
     */
    realEstates?: Array<SearchRealEstateDto>;
}

/**
 * Check if a given object implements the SearchRealEstatesResponse interface.
 */
export function instanceOfSearchRealEstatesResponse(value: object): value is SearchRealEstatesResponse {
    return true;
}

export function SearchRealEstatesResponseFromJSON(json: any): SearchRealEstatesResponse {
    return SearchRealEstatesResponseFromJSONTyped(json, false);
}

export function SearchRealEstatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRealEstatesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'realEstates': json['realEstates'] == null ? undefined : ((json['realEstates'] as Array<any>).map(SearchRealEstateDtoFromJSON)),
    };
}

export function SearchRealEstatesResponseToJSON(json: any): SearchRealEstatesResponse {
    return SearchRealEstatesResponseToJSONTyped(json, false);
}

export function SearchRealEstatesResponseToJSONTyped(value?: SearchRealEstatesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realEstates': value['realEstates'] == null ? undefined : ((value['realEstates'] as Array<any>).map(SearchRealEstateDtoToJSON)),
    };
}

